import { render, staticRenderFns } from "./MintCard.vue?vue&type=template&id=04032f08&scoped=true"
import script from "./MintCard.vue?vue&type=script&lang=js"
export * from "./MintCard.vue?vue&type=script&lang=js"
import style0 from "./MintCard.vue?vue&type=style&index=0&id=04032f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04032f08",
  null
  
)

export default component.exports